import { motion } from "framer-motion";
import { ExternalLink, ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "@/lib/constants";

export default function CaseStudiesSection() {
  return (
    <section className="bg-white py-24" data-testid="case-studies-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div className="max-w-2xl">
            <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Réalisations</div>
            <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-[#0B1F3A] tracking-tight">
              Nos réalisations
            </h2>
            <p className="mt-3 text-[#4B5563] text-lg">
              Des projets concrets pour des entreprises ambitieuses.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((cs, i) => (
            <motion.a
              key={cs.slug}
              href={cs.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`case-card-${cs.slug}`}
              className="group block bg-[#F5F7FA] rounded-2xl overflow-hidden border border-gray-200 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-video overflow-hidden bg-gradient-to-br from-[#F5F7FA] to-white relative">
                <img src={cs.image} alt={cs.title} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute top-4 right-4 h-10 w-10 rounded-full bg-[#0B1F3A] flex items-center justify-center group-hover:bg-[#00B8D9] transition-colors shadow-md">
                  <ArrowUpRight className="h-5 w-5 text-white" />
                </div>
              </div>
              <div className="p-6">
                <div className="text-xs tracking-[0.18em] uppercase font-bold text-[#00B8D9] mb-2">{cs.category}</div>
                <h3 className="font-heading font-extrabold text-2xl text-[#0B1F3A] mb-2">{cs.title}</h3>
                <p className="text-[#4B5563] text-sm mb-4">{cs.description}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {cs.tags.map((t) => (
                    <span key={t} className="text-xs px-2.5 py-1 rounded-full bg-white border border-gray-200 text-[#0B1F3A]">{t}</span>
                  ))}
                </div>
                <div className="flex items-center text-sm font-semibold text-[#00B8D9] group-hover:gap-2 transition-all">
                  Voir le projet <ExternalLink className="h-4 w-4 ml-1" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
